import * as FingerprintProAgent from "@fingerprintjs/fingerprintjs-pro";

/**
 * Fingerprint Pro identification.
 *
 * Only the `requestId` is sent to our server — the visitor ID is looked up
 * server-side with the secret key, so a tampered client cannot choose its own
 * identity.
 *
 * Called at submit time rather than during page-load collection on purpose:
 * the free tier bills per identification, and a visitor who opens the page and
 * abandons should not consume one.
 */
export async function identifyWithFingerprintPro(
  publicKey: string,
  region: "us" | "eu" | "ap",
): Promise<{ requestId: string } | null> {
  try {
    const agent = await FingerprintProAgent.load({ apiKey: publicKey, region });
    const result = await agent.get();
    return result.requestId ? { requestId: result.requestId } : null;
  } catch {
    // Blocked script, offline, exhausted quota, bad key — all non-fatal. The
    // verification proceeds on the other collectors and the server records
    // that the Pro signal was unavailable.
    return null;
  }
}
